//import 'babel-polyfill'
import Vue from 'vue'
// import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/Element_custom_theme/theme/index.css'
import 'font-awesome/css/font-awesome.min.css'
import './assets/css/iconfont/iconfont.css'
import './assets/css/el-custom.css'
import './assets/css/common.css'
import './assets/css/dialog.css'
import './assets/css/fonts.css'
import './assets/css/colors.css'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import i18n from './utils/i18n'
import $cookies from 'vue-cookies'
//import promise from 'es6-promise'
//import 'babel-polyfill';
//import 'babel-polyfill'

Vue.use(i18n);
Vue.use($cookies);
//promise.polyfill();
axios.defaults.withCredentials = false;
Vue.prototype.$http = axios;

Vue.config.productionTip = false
window.bus = new Vue();

new Vue({
  router,
  store,
  i18n,
  $cookies,
  render: h => h(App)
}).$mount('#app')